"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _getDisplayBytes = _interopRequireDefault(require("@devsta/get-display-bytes"));

var _commonReact = require("@devsta/common-react");

require("../styles/_asset-details.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function getAssetMetadata(_ref) {
  var metaData = _ref.metaData;

  if (!metaData) {
    return {};
  }

  try {
    return JSON.parse(metaData);
  } catch (_unused) {
    return {};
  }
}

function AssetDetails(_ref2) {
  var asset = _ref2.asset,
      outputName = _ref2.outputName;

  if (asset === undefined) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "video-asset-details"
    }, /*#__PURE__*/_react.default.createElement("p", null, outputName));
  }

  if (asset === null) {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "video-asset-details"
    }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
      asset: asset,
      height: 50,
      width: 50,
      borderRadius: 4,
      hideFileTypeIcon: true
    }), /*#__PURE__*/_react.default.createElement("p", null, outputName));
  }

  var _getAssetMetadata = getAssetMetadata(asset),
      type = _getAssetMetadata.type,
      size = _getAssetMetadata.size;

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "video-asset-details"
  }, /*#__PURE__*/_react.default.createElement(_commonReact.AssetPreview, {
    asset: asset,
    height: 50,
    width: 50,
    borderRadius: 4,
    hideFileTypeIcon: true
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "video-asset-details__text"
  }, /*#__PURE__*/_react.default.createElement("p", null, outputName), /*#__PURE__*/_react.default.createElement("p", null, "File Type: ".concat(type || 'Unknown').concat(size ? " - ".concat((0, _getDisplayBytes.default)(size)) : ''))));
}

var _default = (0, _commonReact.withAssetSelector)( /*#__PURE__*/(0, _react.memo)(AssetDetails));

exports.default = _default;